import { css } from "@emotion/react"
import { Button, Layout } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"

export const FooterButtons = ({
    onApproveButtonClick,
    onRejectButtonClick,
    isLoading = false
}: {
    onApproveButtonClick: () => Promise<void>
    onRejectButtonClick: () => void
    isLoading?: boolean
}) => {
    const { t } = useTranslation()
    return (
        <Layout.Column
            css={css`
                position: sticky;
                bottom: 0;
                left: 0;
                gap: 14px;
                padding: 16px 16px 34px 16px;
            `}
        >
            <div>
                <Button
                    fullWidth
                    variant="filled"
                    color="primary"
                    onClick={onApproveButtonClick}
                    disabled={isLoading}
                    loading={isLoading}
                >
                    {t("承認")}
                </Button>
            </div>
            <div>
                <Button
                    fullWidth
                    variant="filled"
                    onClick={onRejectButtonClick}
                    disabled={isLoading}
                >
                    {t("却下")}
                </Button>
            </div>
        </Layout.Column>
    )
}
